<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <div style="margin-bottom: 15px;">
      <el-button type="success" @click="shuaixn()">刷新</el-button>
      <el-button type="warning">待还总金额 {{ to_be_returned }} 已还总金额 {{ already_repaid }} 总计 {{ total_amount }} </el-button>
    </div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="会员信息">
          <el-input v-model="searchForm.search" placeholder="真实姓名|手机号|身份证"></el-input>
        </el-form-item>
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
            placeholder="请输入订单号"></el-input></el-form-item>
        <!-- <el-form-item label="配送方式">
            <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData.data" style="width: 100%" v-loading="loading">
          <el-table-column label="ID">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.user.user_id }}
            </template>
          </el-table-column>
          
          <!-- <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column> -->

          <el-table-column prop="" label="姓名">
            <template slot-scope="scope">
              {{ scope.row.username }}
              <!-- <div>昵称：{{ scope.row.user.nickName?scope.row.user.nickName:"null" }}</div> -->
              <!-- <div class="gray9">ID：({{ scope.row.user.user_id }})</div>
              <div>身份证号：{{ scope.row.usernum }}</div>
              <div>手机号：{{ scope.row.user.mobile }}</div>
              <div>订单号：{{ scope.row.order_no }}</div> -->
            </template>
          </el-table-column>

          <el-table-column label="订单号" width="150">
            <template slot-scope="scope">
              {{ scope.row.order_no }}
            </template>
          </el-table-column>

          <el-table-column label="订单信息" width="200">
                <template slot-scope="scope">
                    <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                        <span>{{ item.product_name.slice(0,18) }}</span>
                    </div>
                </template>
            </el-table-column>

          <el-table-column prop="yushou" label="租赁开始时间" width="150">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.update_time }}
            </template>

          </el-table-column>
          <el-table-column prop="yushou" label="总租期">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>1/{{scope.row.order_bill[0].Total_number_of_periods}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="租金(元)">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>￥{{ scope.row.order_bill[0].price }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="已扣金额(元)"  width="150">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <!-- <div>￥{{ yihuanzujin }}</div> -->
              0
            </template>
          </el-table-column>
          <el-table-column prop="is_pay_status" label="支付状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div v-if="scope.row.pay_ztai == 1" style="color: #18BC9C;">已支付</div>
              <div v-else-if="scope.row.pay_ztai == 0" style="color: red;">未支付</div>
              <div v-else>已逾期</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="支付时间" width="150">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.paysj? scope.row.paysj:"-" }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="本期还租时间" width="150">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.bqhzsj | formatDate }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="yushou" label="违约天数">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div> <span v-if="scope.row.wysj" style="color:red;">{{ scope.row.wysj }}</span>  <span v-else>0</span>    天 </div>
            </template>
          </el-table-column>

          <el-table-column prop="zuhoutip" label="备注" width="350">
            <template slot-scope="scope">
              <div>{{ scope.row.zuhoutip }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="flzt" label="法律状态" width="350">
            <template slot-scope="scope">
              <div>{{ scope.row.flzt }}</div>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="250">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div style="display:flex;">
                <el-button @click="addClick(scope.row)" type="info" size="small"
                  v-auth="'/order/order/detail'">订单详情</el-button>
                <el-button @click="gohuankuan(scope.row)" type="primary" size="small">还款详情</el-button>
                <el-button @click="gofengkong(scope.row)" type="success" size="small">备注</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 备注 -->
      <el-dialog title="备注" :visible.sync="dialogVisible5" width="30%">
        <div style="margin-top: 20px;display: flex;align-items: center;">
          <div style="width: 14%;">备注:</div>
          <el-input v-model="bzfrom.inputbeizhu" placeholder="请输入备注信息" style="margin-top:10px;"></el-input>
        </div>

        <div style="margin-top: 20px;display: flex;align-items: center;">
          <div style="margin-right:15px;">法律状态:</div>
          <el-select v-model="bzfrom.inputfl" placeholder="请选择">
            <el-option v-for="item in flztlist" :key="item.val" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible5 = false">取 消</el-button>
          <el-button type="primary" @click="queding5()">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹窗 -->
      <el-dialog title="还款详情" :visible.sync="dialogTableVisible">
        <el-table :data="gridData">
          <el-table-column property="bill_id" label="租期ID"></el-table-column>
          <el-table-column property="current_period" label="期数"></el-table-column>
          <el-table-column property="price" label="应还款金额"></el-table-column>
          <el-table-column label="还款时间">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.repayment_date | formatDate }}</span>
            </template>
          </el-table-column>

          <el-table-column label="支付时间">
            <template slot-scope="scope">
              <span v-if="scope.row.paytime > 0" style="margin-left: 10px">{{ scope.row.paytime | formatDate }}</span>
            </template>
          </el-table-column>

          <el-table-column label="是否已经还">
            <template slot-scope="scope">
              <template v-if="scope.row.is_pay_status == 0">
                <span style="margin-left: 10px;color:#FF0000;">未还</span>
              </template>
              <template v-else-if="scope.row.is_pay_status == 1">
                <span style="margin-left: 10px;color:cornflowerblue;">已还</span>
              </template>
              <template v-else-if="scope.row.is_pay_status == 2">
                <span style="margin-left: 10px">逾期</span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog='closeLogistics'> </Logistics>
  </div>
</template>

<script>
import store from "@/store/";
import AuthApi from '@/api/auth.js';
import OrderApi from '@/api/order.js';
import { timeFormat } from "@/utils/timeFormat"
import Logistics from '@/components/logistics/viewLogistics.vue'
import qs from 'qs';
export default {
  name: 'Login',
  components: {
    Logistics
  },
  data() {
    return {
      bzfrom: {
        inputbeizhu: "", //备注信息
        inputfl: "", //法律状态
      },
      flztlist: [{
        name: '正常',
        val: 1
      },
      {
        name: '失联',
        val: 2
      },
      {
        name: '律师函已发',
        val: 3
      },
      {
        name: '起诉',
        val: 4
      },
      {
        name: '约定还款时间',
        val: 5
      },
      {
        name: '部分已还',
        val: 6
      },
      {
        name: '关机',
        val: 7
      },
      {
        name: '通话中未接拒绝',
        val: 8
      }
      ],
      total_amount: "",
      to_be_returned: "",
      already_repaid: "",
      gridData: "",
      dialogTableVisible: false,
      //备注
      dialogVisible5: false,
      //类型
      leixing: '',
      //违约天数
      xiaoyu: '',
      //还租时间
      zhuande: '',
      zhifushijian: '',
      zhifuzhuangtai: '',
      yihuanzujin: '',
      diyizujin: '',
      yuqijine: '',
      // 时间格式化
      time: '',
      // 十位数 时间戳
      timeTemp: '',
      // 十三位数 时间戳
      timesTemp: '',
      zujin: "",
      shop_url: "",
      htdata: "",
      // 签署id
      folwid: '',
      //碎屏险
      radio: "2",
      // order_id 订单id
      order_id: "",
      remarksText: "",
      remarksText1: "",
      // 输入框值
      yushou: "",
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: '',
        order_no: '',
        style_id: '',
        create_time: '',
        total_price: '',
        price: '',
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',

      total_price: '',
      peice: '',


      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0
      },
      isLogistics: false,
      logisticsData: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    gojiedong(row) {
      this.$confirm('确定要解冻?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.ysunfreeze(data, true)
          .then(res => {
            console.log("成功res", res);
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*押金转租金*/
    goyajin(row) {
      this.order_id = row.order_id;
      this.dialogVisible3 = true;
    },
    /*删除订单*/
    godelete(row) {
      this.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.delete(data, true)
          .then(res => {
            console.log("成功res", res);
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //确定订单
    goque(row) {
      console.log("======", row.user.user_id);
      this.$confirm('确定要收获订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
          user_id: row.user_id,
        }
        OrderApi.receipt(data, true)
          .then(res => {
            console.log("成功res", res);
            this.$message({
              type: 'success',
              message: '确认成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },

    /*弹窗确定*/
    queding() {
      console.log(this.shneheList);
      if (this.shneheList.length <= 0) {
        this.$message({
          message: '请选择归还期数',
          type: 'error'
        });
        return;
      }
      OrderApi.toExamine({
        billid: this.shneheList
      }, true).then(data => {
        this.dialogVisible = false;
        console.log(data, "成功");
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*风控备注弹窗确定*/
    queding5() {
      let Params = {
        order_id: this.order_id,
        flzt: this.bzfrom.inputfl,
        zuhoutip: this.bzfrom.inputbeizhu
      };
      console.log(Params);
      OrderApi.zhflzt(Params, true)
        .then(data => {
          console.log("成功返回的data", data);
          this.$message({
            message: data.msg,
            type: 'success'
          });
          this.getData();
          this.dialogVisible5 = false;
        })
        .catch(error => { });

      // let Params = {
      //   order_id: this.order_id,
      //   remarksType: 2,
      //   remarksText: this.remarksText1
      // }
      // OrderApi.orderRemarks(Params, true)
      //   .then(res => {
      //     this.dialogVisible5 = false;
      //     this.$message({
      //       message: '操作成功',
      //       type: 'success'
      //     });
      //   })
    },
    /* 还款详情 */
    gohuankuan(row) {
      this.dialogTableVisible = true;
      let Params = {
        order_id: row.order_id
      }
      OrderApi.zuqi(Params, true)
        .then(res => {
          console.log("成功", res);
          this.gridData = res.data.billList
        })
        .catch(error => { });
    },
    /*风控备注*/
    gofengkong(row) {
      this.bzfrom.inputfl= row.flzt;
      this.bzfrom.inputbeizhu = row.zuhoutip;
      this.dialogVisible5 = true;
      this.order_id = row.order_id;
      console.log(this.order_id);
    },
    handleClose5() {
      this.dialogVisible5 = false;
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

   /*获取列表*/
   async getData() {
      let self = this;
      self.loading = true;
      let Params = this.searchForm;
      var resp = await store.dispatch("common/getBaseInfo");
      if (resp.role != "") {
        if (resp.role[0].role_id == 4) {
          Params.tuiguang_id = Params.tuiguang_id;
        }
      } else {
        Params.tuiguang_id = "";
      }
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      OrderApi.orderlist2(Params, true)
        .then(res => {
          self.loading = false;
          let list = [];
          //已还
          self.already_repaid = res.data.statistics.already_repaid
          //待归还
          self.to_be_returned = res.data.statistics.to_be_returned
          //总计
          self.total_amount = res.data.statistics.total_amount
          self.tableData = res.data.list;

          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            // console.log("item",item);
            for (let j = 0; j < item.order_bill.length; j++) {
              let data = item.order_bill[j];
              if (data.is_pay_status == 0 || data.is_pay_status == 2) {
                // console.log("data",data);
                item.bqhzsj = data.repayment_date;
                item.pay_ztai = data.is_pay_status;
                item.paysj = data.paytime;
                break
              }
            }
            self.tableData.data[i] = item;
          }

          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            // console.log("item",item);
            for (let j = 0; j < item.order_bill.length; j++) {
              let data = item.order_bill[j];
              if (data.is_pay_status == 2) {
                // console.log("逾期 data",data.repayment_date);
                let d1 = data.repayment_date  * 1000;
                let d2 = Date.parse(new Date());
                let time = d2 - d1;
                item.wysj = (Math.trunc(time/(1000*60*60*24)))
              }
            }
            self.tableData.data[i] = item;
          }

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => { });
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({ path: '/order/order/Detail', query: { order_id: params } });
      window.open(routeData.href, '_blank');
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      }
      // self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then(res => {
          self.logisticsData = res.data.express.list;
          self.loading = false;

          self.openLogistics()
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    }
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
    },

  },
};
</script>
<style lang="scss">
.labeldata{
  display: inline;
    padding: 0.2em 0.6em 0.3em;
    font-size: 75%;
    font-weight: bold;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25em;
    background-color: #18bc9c;
}
.el-table td,
.el-table th {
  padding: 0;
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #FFA49F;
  padding: 5px;
  background-color: #FFF1F0;
  color: #F6363E;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 2px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}</style>



// WEBPACK FOOTER //
// src/views/order/order/dhindex.vue